// src/api/client.ts
import createClient, { type Middleware } from "openapi-fetch";

import { session } from "@/auth/session";
import { getDeviceId } from "@/lib/device-id";

import { ApiError, detailToMessage, withRetryHint } from "./errors";
import type { paths } from "./schema";

// رابط الباك إند ثابت في الكود مباشرة — بلا أي اعتماد على متغيّر بيئة (VITE_API_BASE_URL) تحت أي ظرف،
// في التطوير أو الإنتاج أو الاختبارات. أي تغيير للرابط لازم يكون تعديل مباشر في السطر ده.
export const API_BASE = "https://api.adman-sa.com";

const authMiddleware: Middleware = {
  onRequest({ request }) {
    const token = session.token();
    if (token && !request.headers.has("Authorization")) request.headers.set("Authorization", `Bearer ${token}`);
    if (!request.headers.has("X-Device-Id")) request.headers.set("X-Device-Id", getDeviceId());
    return request;
  },
  onResponse({ response, request }) {
    // 401 على طلب موثّق = انتهت الجلسة. محاولة الدخول نفسها (token) خارج هذه القاعدة، وكذلك رمز التحقق الثنائي
    // الخاطئ أثناء التفعيل/التعطيل (يرجع 401 لكن الجلسة سليمة ولا يجوز طرد المستخدم بسببه).
    if (response.status === 401 && session.token() && !request.url.endsWith("/api/auth/token") && !request.url.includes("/api/auth/2fa/")) session.clear();
    return response;
  },
};

export const api = createClient<paths>({ baseUrl: API_BASE });
api.use(authMiddleware);

type Result<T> = { data?: T; error?: unknown; response: Response };

/** يفك نتيجة openapi-fetch: يرجع البيانات أو يرمي ApiError برسالة عربية جاهزة للعرض. */
export async function call<T>(promise: Promise<Result<T>>): Promise<T> {
  const { data, error, response } = await promise;
  if (!response.ok || error !== undefined) {
    const retry = Number(response.headers.get("retry-after"));
    throw new ApiError(response.status, withRetryHint(detailToMessage(response.status, error), response.status, retry > 0 ? retry : undefined), error, response.headers.get("x-mfa-required") === "true", retry > 0 ? retry : undefined);
  }
  return data as T;
}
